// extracted by mini-css-extract-plugin
export var altContainer = "Showcase-module--altContainer--bf382";
export var alternateTitle = "Showcase-module--alternate-title--dc6b0";
export var container = "Showcase-module--container--0b692";
export var dark = "Showcase-module--dark--faee7";
export var main = "Showcase-module--main--10cc3";
export var reverse = "Showcase-module--reverse--08ac6";
export var secondary = "Showcase-module--secondary--8e87d";
export var showcase = "Showcase-module--showcase--aa7b0";
export var subtext = "Showcase-module--subtext--4b517";
export var subtitle = "Showcase-module--subtitle--32434";
export var tablet = "Showcase-module--tablet--f2c35";
export var title = "Showcase-module--title--17a45";